import { createWebHashHistory, createRouter } from "vue-router";
import Mosaic from '@/components/Mosaic'
import Planes from '@/components/Planes'
import Main from '@/components/Main'
import Letter from '@/components/Letter'
import Color from '@/components/Color'

const routes = [
  {
    path: '/Mosaic',
    name: 'Mosaic',
    component: Mosaic,
  },
  {
    path: '/planes',
    name: 'Planes',
    component: Planes,
  },
  {
    path: '/',
    name: 'Main',
    component: Main,
  },
  {
    path: '/color',
    name: 'Color',
    component: Color,
  },
  {
    path: '/letter',
    name: 'Letter',
    component: Letter,
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router
